module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewContainer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOrder),
      expression: "isOrder"
    }],
    on: {
      "listenEdit": _vm.showOrder
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "活动ID："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "输入活动ID",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.flexibleCode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "flexibleCode", $$v)
      },
      expression: "filters.flexibleCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "商品名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.goodsName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "goodsName", $$v)
      },
      expression: "filters.goodsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "活动时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择时间"
    },
    model: {
      value: (_vm.filters.strStart),
      callback: function($$v) {
        _vm.$set(_vm.filters, "strStart", $$v)
      },
      expression: "filters.strStart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("幸运购活动")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.fuzhiCopy()
      }
    }
  }, [_vm._v("复制活动")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handleinfo('', 1)
      }
    }
  }, [_vm._v("新增")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动ID",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.flexibleCode
          }
        }, [_vm._v(_vm._s(scope.row.flexibleCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.goodsName
          }
        }, [_vm._v(_vm._s(scope.row.goodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价格(元)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodsPrice))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "中奖名额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.personWinningNum))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动时间",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.eventDateStart) + " - " + _vm._s(scope.row.eventDateEnd))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开奖时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.eventDateEndTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "单人次价格(元)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.personPrice))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已参与人数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.personPastNum))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.eventStatusMsg))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.eventStatus == 3) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.endToExamine(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-trophy"
        }), _vm._v(" 开奖\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.eventStatus != 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleinfo(scope.row, 3)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.eventStatus == 4 && scope.row.lotteryStatus == true) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleSendaPrize(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-truck"
        }), _vm._v(" 派奖\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.eventStatus == 2 || scope.row.eventStatus == 3) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.xiaxian(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-remove-outline"
        }), _vm._v(" 关闭\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.eventStatus == 3 || scope.row.eventStatus == 4) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.choujiang(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-present"
        }), _vm._v(" 抽奖\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.eventStatus == 1) ? [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.fabu(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        }), _vm._v(" 开启 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleinfo(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteMerchant(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除 ")])] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageInfo.pageNum,
      "page-size": 10,
      "total": _vm.totalRowsCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), (_vm.isOrderWatch) ? _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "活动信息",
      "name": "first"
    }
  }), _vm._v(" "), (_vm.decorationSeeDis) ? _c('el-tab-pane', {
    attrs: {
      "label": "参与信息",
      "name": "second"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.decorationSeeDis) ? _c('el-tab-pane', {
    attrs: {
      "label": "推广记录",
      "name": "third"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'first'),
      expression: "activeName=='first'"
    }],
    staticClass: "main_container"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("活动基本信息")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form', {
    staticClass: "decorationDiaryDiv"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动时间：",
      "label-width": "120px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "66%",
      "cursor": "pointer",
      "background": "#fff",
      "border": "1px solid #eee"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "value-format": "yyyy-MM-dd",
      "disabled": _vm.decorationSeeDis,
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.hdsjTime
    },
    model: {
      value: (_vm.groupWork.huodongTime),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "huodongTime", $$v)
      },
      expression: "groupWork.huodongTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开奖时间：",
      "label-width": "120px"
    }
  }, [_c('el-time-select', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "选择时分",
      "picker-options": {
        start: '07:00',
        step: '00:15',
        end: '24:00'
      },
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.kjTime),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "kjTime", $$v)
      },
      expression: "groupWork.kjTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "直播间号码：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "例：12345678",
      "maxlength": "20",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.diaryName),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "diaryName", $$v)
      },
      expression: "groupWork.diaryName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "例如：欧派橱柜XXXX型号",
      "maxlength": "20",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.spmc),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "spmc", $$v)
      },
      expression: "groupWork.spmc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品价格：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "例：5888.88元",
      "maxlength": "7",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.commodityPrice),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "commodityPrice", $$v)
      },
      expression: "groupWork.commodityPrice"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品描述：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "例如：品质橱柜-健康生活360",
      "maxlength": "20",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.productDescription),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "productDescription", $$v)
      },
      expression: "groupWork.productDescription"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分享标题：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "大家一起来帮我装修吧~",
      "maxlength": "50",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.decorationPeriod),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "decorationPeriod", $$v)
      },
      expression: "groupWork.decorationPeriod"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupWork.houseType == 1),
      expression: "groupWork.houseType == 1"
    }],
    attrs: {
      "label": "参与价格：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "请输入",
      "maxlength": "8",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.housingArea),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "housingArea", $$v)
      },
      expression: "groupWork.housingArea"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("元")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动主图：",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "uploadActive"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "disabled": _vm.decorationSeeDis,
      "before-upload": function (file) { return _vm.beforUploadThree(file, 1); }
    }
  }, [(_vm.groupWork.zbjbjUrl) ? _c('div', {
    staticClass: "fxfmImgUrl"
  }, [_c('el-image', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.groupWork.zbjbjUrl,
      "fit": "cover"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.groupWork.zbjbjUrl) ? _c('div', {
    staticClass: "fxfmImgUrl"
  }, [_c('i', {
    staticClass: "el-icon-plus upBtn"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("尺寸：1200*675，支持的图片格式：jpg、png。")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分享封面：",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "uploadActive"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "disabled": _vm.decorationSeeDis,
      "before-upload": function (file) { return _vm.beforUploadThree(file, 2); }
    }
  }, [(_vm.groupWork.fxtpUrl) ? _c('div', {
    staticClass: "fxfmImgUrl"
  }, [_c('el-image', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.groupWork.fxtpUrl,
      "fit": "cover"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.groupWork.fxtpUrl) ? _c('div', {
    staticClass: "fxfmImgUrl"
  }, [_c('i', {
    staticClass: "el-icon-plus upBtn"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("尺寸：1000*800，支持的图片格式：jpg、png。")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "视频（选填）：",
      "label-width": "120px"
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1)], 1), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": ""
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品图片：",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "upPictures"
  }, [_vm._l((_vm.detailImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "multigraph",
      attrs: {
        "data-img": item
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.picUrl,
        "preview-src-list": [item.picUrl]
      },
      on: {
        "click": _vm.handleClickItem
      }
    }), _vm._v(" "), (!_vm.decorationSeeDis) ? _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deldetail(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      }
    })]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.flag < 5) ? _c('el-upload', {
    attrs: {
      "action": "",
      "multiple": "",
      "before-upload": _vm.beforeAvatarUpload,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [(!_vm.decorationSeeDis) ? _c('i', {
    staticClass: "el-icon-plus upBtn"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "clear": "both"
    }
  }, [_vm._v("尺寸：1200*1200，支持的图片格式：jpg、png。")])], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("活动形式配置")]), _vm._v(" "), _c('el-form', {
    staticClass: "decorationDiaryDiv"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "0 0 10px 10px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.xingshi),
      callback: function($$v) {
        _vm.xingshi = $$v
      },
      expression: "xingshi"
    }
  }, [_vm._v("形式一（不限制参与人数）")])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0 0 10px 6px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.xingshi),
      callback: function($$v) {
        _vm.xingshi = $$v
      },
      expression: "xingshi"
    }
  }, [_vm._v("形式二（固定参与人数和奖品数量）")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "参与人数每满：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "placeholder": "请输入",
      "maxlength": "20",
      "disabled": _vm.decorationSeeDis || _vm.xingshi == 2
    },
    model: {
      value: (_vm.groupWork.cyrsmm),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "cyrsmm", $$v)
      },
      expression: "groupWork.cyrsmm"
    }
  }), _vm._v(" 人奖品增加一份\r\n            ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "可参与人数：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "设定可参与人数",
      "maxlength": "20",
      "disabled": _vm.decorationSeeDis || _vm.xingshi == 1
    },
    model: {
      value: (_vm.groupWork.partake),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "partake", $$v)
      },
      expression: "groupWork.partake"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "中奖名额：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "请输入",
      "maxlength": "20",
      "disabled": _vm.decorationSeeDis || _vm.xingshi == 1
    },
    model: {
      value: (_vm.groupWork.zjrs),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "zjrs", $$v)
      },
      expression: "groupWork.zjrs"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("领奖信息")]), _vm._v(" "), _c('el-form', {
    staticClass: "decorationDiaryDiv"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "请输入",
      "maxlength": "20",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.shopName),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "shopName", $$v)
      },
      expression: "groupWork.shopName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺地址：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "请输入",
      "maxlength": "50",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.shopAddress),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "shopAddress", $$v)
      },
      expression: "groupWork.shopAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电话号码：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "例：13812345678",
      "maxlength": "11",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.groupWork.telephoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.groupWork, "telephoneNumber", $$v)
      },
      expression: "groupWork.telephoneNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品详情")]), _vm._v(" "), _c('wjEditor', {
    staticStyle: {
      "width": "97%",
      "margin": "0 auto"
    },
    attrs: {
      "desc": _vm.productProfile
    },
    on: {
      "change": _vm.contentChangeOne
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('wjEditor', {
    staticStyle: {
      "width": "97%",
      "margin": "0 auto"
    },
    attrs: {
      "desc": _vm.activityDesc
    },
    on: {
      "change": _vm.contentChangeTwo
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "boldTitle"
  }, [_vm._v("创客分享奖现金：")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.decorationSeeDis),
      expression: "!decorationSeeDis"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addAndPreservation(2)
      }
    }
  }, [_vm._v("配置")]), _vm._v(" "), (_vm.seejlfsTwo != '') ? [_c('span', {
    staticClass: "threePrice"
  }, [_vm._v("单份奖励：" + _vm._s(_vm.rewardTwo) + "元")]), _vm._v(" "), _c('span', {
    staticClass: "threePrice"
  }, [_vm._v("奖励份数：" + _vm._s(_vm.seejlfsTwo) + "份")]), _vm._v(" "), _c('span', {
    staticClass: "threePrice"
  }, [_vm._v("需充值金额：" + _vm._s(Math.ceil(_vm.recharge.totalprice * 100) / 100) + " 元")])] : [_c('span', {
    staticClass: "threePrice"
  }, [_vm._v("无配置")])], _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.decorationSeeDis && _vm.seejlfsTwo != ''),
      expression: "!decorationSeeDis && seejlfsTwo !=''"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.chongzhiPz
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin": "10px 0",
      "display": "inline-block"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.decorationSeeDis ? '返回' : '取消'))]), _vm._v(" "), (!_vm.decorationSeeDis) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addAndPreservation(1)
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'second'),
      expression: "activeName=='second'"
    }],
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "canyuxinxi"
  }, [_c('span', [_vm._v("需要参与人数："), _c('b', [_vm._v(_vm._s(_vm.participationInStatistics.person_max_num) + "  人")])]), _vm._v(" "), _c('span', [_vm._v("实际参与人数："), _c('b', [_vm._v(_vm._s(_vm.participationInStatistics.personPastNum) + "  人")])]), _vm._v(" "), _c('span', [_vm._v("兑换优惠券："), _c('b', [_vm._v(_vm._s(_vm.participationInStatistics.personPast4Num) + " 人")])]), _vm._v(" "), _c('span', [_vm._v("退款："), _c('b', [_vm._v(_vm._s(_vm.participationInStatistics.personPast3Num) + " 人")])]), _vm._v(" "), _c('span', [_vm._v("待处理："), _c('b', [_vm._v(_vm._s(_vm.participationInStatistics.personPastOtherNum) + " 人")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.onExport()
      }
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_inner_container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    staticStyle: {
      "height": "auto",
      "max-height": "500px"
    },
    attrs: {
      "data": _vm.participationInformationList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    key: "1",
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邀请员工昵称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.individualUserName))]
      }
    }], null, false, 1764333410)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邀请员工手机号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.individualUserPhone))]
      }
    }], null, false, 811392025)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户手机号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.userTel))]
      }
    }], null, false, 302853169)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开奖号码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.pastNumber))]
      }
    }], null, false, 3724607176)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参与时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.createTime))]
      }
    }], null, false, 1993746252)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否中奖",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.prizes == '' || scope.row.prizes == null || scope.row.prizes == '-' ? '否' : '是'))]
      }
    }], null, false, 1252025568)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "奖品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.prizes
          }
        }, [_vm._v(_vm._s(scope.row.prizes))])]
      }
    }], null, false, 3748492228)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.pastStatusMsg))]
      }
    }], null, false, 899957542)
  })], 1)], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin-top": "10px",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.canyuTotalCount
    },
    on: {
      "current-change": _vm.handleCanyuXinxi
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-bottom": "10px",
      "display": "inline-block"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOrder()
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'third'),
      expression: "activeName=='third'"
    }],
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "reminder",
    staticStyle: {
      "margin": "15px"
    }
  }, [_vm._v("\r\n        分享奖励：每份 "), _c('b', [_vm._v(_vm._s(_vm.tgdetails.univalence))]), _vm._v(" 元，　\r\n        共 "), _c('b', [_vm._v(_vm._s(_vm.tgdetails.totalcount))]), _vm._v(" 份　\r\n        已领取 "), _c('b', {
    staticClass: "redClass"
  }, [_vm._v(_vm._s(_vm.tgdetails.consumecount))]), _vm._v(" 份　\r\n        剩余 "), _c('b', {
    staticClass: "redClass"
  }, [_vm._v(_vm._s(_vm.tgdetails.remaincount))]), _vm._v(" 份　\r\n        余额 "), _c('b', {
    staticClass: "redClass"
  }, [_vm._v(_vm._s(_vm.tgdetails.remainprice))]), _vm._v(" 元　\r\n        退款金额："), _c('b', [_vm._v(_vm._s(_vm.tgdetails.refundprice))]), _vm._v(" 元\r\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticClass: "invoice_tab tabler_inner_container",
    staticStyle: {
      "height": "auto",
      "max-height": "500px"
    },
    attrs: {
      "data": _vm.tkjlList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "领取时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.createtime))]
      }
    }], null, false, 2711533740)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分享者手机号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }], null, false, 2034370561)
  })], 1)], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 10px 0 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageCkfxindex,
      "page-size": 10,
      "total": _vm.ckfxCount
    },
    on: {
      "current-change": _vm.ckfxfenye
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-bottom": "10px",
      "display": "inline-block"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOrder()
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "复制活动",
      "visible": _vm.isToCopy,
      "width": "44%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.isToCopy = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "formItem"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "原活动时间 :",
      "label-width": "88px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v(_vm._s(_vm.originalActivityTimeStart) + " - " + _vm._s(_vm.originalActivityTimeEnd))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "开奖时间 :",
      "label-width": "88px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v(_vm._s(_vm.openingTime))])])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "formItem"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "新活动时间 :",
      "label-width": "88px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%",
      "cursor": "pointer",
      "background": "#fff",
      "border": "1px solid #eee"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.changeActiveTime
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "开奖时间 :",
      "label-width": "88px"
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": "选择时间",
      "picker-options": {
        start: '07:00',
        step: '00:15',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.spikeTime),
      callback: function($$v) {
        _vm.spikeTime = $$v
      },
      expression: "spikeTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToCopy = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "开奖管理",
      "visible": _vm.isToComment,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.isToComment = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "15px"
    },
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.kjradio),
      callback: function($$v) {
        _vm.kjradio = $$v
      },
      expression: "kjradio"
    }
  }, [_vm._v("正常开奖")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.kjradio),
      callback: function($$v) {
        _vm.kjradio = $$v
      },
      expression: "kjradio"
    }
  }, [_vm._v("本次活动人数未达标，不予开奖")]), _vm._v(" "), _c('p', {
    staticClass: "zyts"
  }, [_vm._v("重要提示：请谨慎操作，确定开奖后不可修改")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToComment = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.endDrawaPrize()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "派奖管理",
      "visible": _vm.isToExamine,
      "width": "40%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_vm._l((_vm.paijiangList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "formItem"
    }, [_c('ul', {
      staticClass: "classPrize"
    }, [_c('li', [_c('b', [_vm._v("开奖号码: ")]), _vm._v(" " + _vm._s(item.pastNumber))]), _vm._v(" "), _c('li', [_c('b', [_vm._v("奖品: ")]), _vm._v(" "), _c('div', {
      staticClass: "textexceeds",
      attrs: {
        "title": item.prizes
      }
    }, [_vm._v(_vm._s(item.prizes))])]), _vm._v(" "), _c('el-checkbox', {
      staticStyle: {
        "float": "right"
      },
      model: {
        value: (item.pastStatus),
        callback: function($$v) {
          _vm.$set(item, "pastStatus", $$v)
        },
        expression: "item.pastStatus"
      }
    }, [_vm._v("已派奖")])], 1)])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.endSendaPrize()
      }
    }
  }, [_vm._v("确定")])], 1)], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "创客分享奖现金",
      "visible": _vm.prizeCash,
      "center": true,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.prizeCash = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "单份奖励："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入",
      "onkeyup": "this.value=this.value.replace(/\\D|^0/g,'')"
    },
    model: {
      value: (_vm.rewardTwo),
      callback: function($$v) {
        _vm.rewardTwo = $$v
      },
      expression: "rewardTwo"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "奖励份数："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入奖励份数",
      "maxlength": "7"
    },
    model: {
      value: (_vm.recharge.totalcount),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "totalcount", $$v)
      },
      expression: "recharge.totalcount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "充值金额："
    }
  }, [_c('span', [_c('b', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v(_vm._s(Math.ceil(_vm.recharge.totalprice * 100) / 100))]), _vm._v(" 元")])])], 1), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "label": "分享规则："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.fxdpyq),
      callback: function($$v) {
        _vm.fxdpyq = $$v
      },
      expression: "fxdpyq"
    }
  }, _vm._l((_vm.tasktyps), function(item) {
    return _c('el-radio', {
      key: item.bttid,
      staticStyle: {
        "margin-right": "15px"
      },
      attrs: {
        "label": item.bttid
      }
    }, [_vm._v(_vm._s(item.tasktypename))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "分享文案："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入分享文案内容",
      "maxlength": "100",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.recharge.remark),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "remark", $$v)
      },
      expression: "recharge.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "label": "分享要求："
    }
  }, [(_vm.tasktyps.length > 0) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, _vm._l((_vm.tasktyps.find(function (t) { return t.bttid == _vm.fxdpyq; }).descriptions), function(desc, index) {
    return _c('ul', {
      key: index
    }, [(desc.taskdesc.startsWith('【朋友圈】') || desc.taskdesc.startsWith('【微信群】')) ? _c('li', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\r\n              " + _vm._s(desc.taskdesc) + "\r\n            ")]) : _c('li', {
      staticStyle: {
        "color": "#999",
        "line-height": "30px"
      }
    }, [_vm._v("\r\n              " + _vm._s(desc.taskdesc) + "\r\n            ")])])
  }), 0) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("创客范围："), _c('span', [_vm._v("【本功用于配置哪些创客来进行推广】")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("按从事行业：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "800px"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "change": _vm.handleCheckedCities
    },
    model: {
      value: (_vm.formmenuOne),
      callback: function($$v) {
        _vm.formmenuOne = $$v
      },
      expression: "formmenuOne"
    }
  }, _vm._l((_vm.industry), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formmenuOne.find(function (i) { return i == 2; })),
      expression: "formmenuOne.find(i=>i==2)"
    }],
    staticStyle: {
      "height": "200px",
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("按建材品类：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "display": "grid",
      "padding": "0 10px 0 0"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminateTwo
    },
    on: {
      "change": function($event) {
        return _vm.handleCheckAllChange(_vm.checkAlltwo, 2)
      }
    },
    model: {
      value: (_vm.checkAlltwo),
      callback: function($$v) {
        _vm.checkAlltwo = $$v
      },
      expression: "checkAlltwo"
    }
  }, [_vm._v("\r\n          全部\r\n        ")]), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    staticClass: "cktree",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "show-checkbox": "",
      "data": _vm.category,
      "node-key": "id",
      "highlight-current": "",
      "props": _vm.defaultProps,
      "default-checked-keys": _vm.formmenuTwo
    }
  })], 1)]), _vm._v(" "), _c('b', {
    staticStyle: {
      "display": "block",
      "margin": "10px 0 5px 0"
    }
  }, [_vm._v("付费推广目的：")]), _vm._v(" "), _c('ul', [_vm._l((_vm.ckfxjxj), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "line-height": "32px"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("4.示例截图")]), _vm._v(" "), (_vm.tasktyps.length > 0) ? _c('ul', {
    staticClass: "videoandpic"
  }, _vm._l((_vm.tasktyps.find(function (i) { return i.bttid == _vm.fxdpyq; }).examples), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.mediatype == 2),
        expression: "item.mediatype == 2"
      }],
      staticClass: "el-icon-video-play mengceng"
    }), _vm._v(" "), _c('el-image', {
      staticStyle: {
        "width": "100px",
        "height": "100px"
      },
      attrs: {
        "src": _vm.baseOssUrl + item.mediapath,
        "fit": "cover",
        "preview-src-list": [_vm.baseOssUrl + item.mediapath]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), 0) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.prizeCash = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handleJxj()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请使用微信扫码支付",
      "visible": _vm.wxsmzfVisible,
      "width": "20%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.wxsmzfVisible = $event
      },
      "close": function($event) {
        return _vm.closeWxsmzf()
      }
    }
  }, [_c('div', {
    staticClass: "wxsmzfClass"
  }, [_c('P', [_vm._v(_vm._s(_vm.wxsmzfJine) + " 元")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.wxSmzfImg
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片剪裁",
      "visible": _vm.cropping,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cropping = $event
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "fixedBox": _vm.option.fixedBox,
      "outputType": _vm.option.outputType,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "infoTrue": _vm.option.infoTrue,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "info": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "centerBox": _vm.option.centerBox,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cropping = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认提示",
      "visible": _vm.fufeidialog,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.fufeidialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "10px 0 20px 0",
      "font-size": "16px"
    }
  }, [_vm._v("确定要支付推广费用后开启活动吗?")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("-" + _vm._s(_vm.zysj) + " 元")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.fufeidialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.qdfufeu()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "充值提示",
      "visible": _vm.chongzhidialog,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.chongzhidialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "10px 0 30px 0",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.chognzhitishi))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chongzhidialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.quchongzhi()
      }
    }
  }, [_vm._v("去充值")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择店铺",
      "visible": _vm.dialogVisibleadd,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    on: {
      "change": _vm.handleChangedptype
    },
    model: {
      value: (_vm.filters.shopid),
      callback: function($$v) {
        _vm.$set(_vm.filters, "shopid", $$v)
      },
      expression: "filters.shopid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "redTishi"
  }, [_c('span', [_vm._v("本页面内容除，视频为选填，其它全部为必填项。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "boldTitle"
  }, [_vm._v("付费推广\r\n        "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（活动结束后未使用的推广费用，5个工作日内将自动退款到原微信支付账户。）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa4cfce6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/operationManagement/shoppingActivities.vue
// module id = 1734
// module chunks = 3